module.exports = __webpack_public_path__ + "img/uda.a2e324d2.png";